import { useCallback, useRef, useState } from 'react'

export function useRovingFocus(itemCount: number) {
  const [activeIndex, setActiveIndex] = useState(0)
  const refs = useRef<(HTMLElement | null)[]>([])

  const focusItem = useCallback((index: number) => {
    const element = refs.current[index]
    if (!element) return

    setActiveIndex(index)

    element.focus()
    element.scrollIntoView({
      behavior: 'smooth',
      inline: 'center',
      block: 'nearest'
    })
  }, [])

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'ArrowRight') {
        console.log(refs)
        event.preventDefault()
        focusItem(Math.min(activeIndex + 1, itemCount - 1))
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault()
        focusItem(Math.max(activeIndex - 1, 0))
      }

      if (event.key === 'Home') {
        event.preventDefault()
        focusItem(0)
      }

      if (event.key === 'End') {
        event.preventDefault()
        focusItem(itemCount - 1)
      }
    },
    [activeIndex, itemCount, focusItem]
  )

  const getItemProps = (index: number) => ({
    itemRef: (element: HTMLElement | null) => (refs.current[index] = element),
    tabIndex: index === activeIndex ? 0 : -1,
    onFocus: () => setActiveIndex(index)
  })

  return {
    activeIndex,
    focusItem,
    getItemProps,
    onKeyDown
  }
}
